import './Box.css';
import './Flex.css';
import './Padding.css';
import React from 'react';
import classnames from 'classnames';
import camelCase from '../utils/camelCase';

interface BoxParams {
  padding?: number;
  paddingRight?: number;
  paddingLeft?: number;
  paddingTop?: number;
  paddingBottom?: number;
  paddingHorizontal?: number;
  paddingVertical?: number;
  marginRight?: number;
  marginLeft?: number;
  marginTop?: number;
  marginBottom?: number;
  marginHorizontal?: number,
  marginVertical?: number,
  background?: string;
  children?: any;
  className?: string;
  flex?: boolean;
  direction?: string;
  inlineFlex?: boolean;
  justifyContent?: string;
  alignItems?: string;
  divider?: boolean;
  dividerColor?: string;
  rightDivider?: boolean;
  border?: boolean;
  borderRadius?: number;
  onClick?(e: any): void;
  cursor?: string;
  grow?: boolean;
  style?: any;
  dividerSide?: string;
  width?: string;
  textAlignRight?: boolean;
}

function Box({
  children,
  className,
  background,
  padding,
  paddingRight,
  paddingLeft,
  paddingTop,
  paddingBottom,
  paddingHorizontal,
  paddingVertical,
  marginRight,
  marginLeft,
  marginTop,
  marginBottom,
  marginHorizontal,
  marginVertical,
  flex,
  direction,
  inlineFlex,
  justifyContent,
  alignItems,
  divider,
  dividerColor,
  border,
  borderRadius,
  onClick,
  cursor,
  grow,
  style,
  dividerSide,
  width
}: BoxParams) {
  const boxClass = classnames(
    'Box',
    className,
    !inlineFlex &&
    (
      (
        flex ||
        justifyContent ||
        alignItems ||
        direction
      ) &&
      'Flex-flex'
    ),
    inlineFlex && `Flex-inlineFlex`,
    justifyContent && `Flex-justifyContent--${camelCase(justifyContent)}`,
    direction && `Flex-direction--${direction}`,
    grow && `Flex-grow`,
    alignItems && `Flex-alignItems--${camelCase(alignItems)}`,
    padding && `Padding--${padding}`,
    paddingRight && `Padding-right--${paddingRight}`,
    paddingLeft && `Padding-left--${paddingLeft}`,
    paddingTop && `Padding-top--${paddingTop}`,
    paddingBottom && `Padding-bottom--${paddingBottom}`,
    paddingHorizontal && `Padding-horizontal--${paddingHorizontal}`,
    paddingVertical && `Padding-vertical--${paddingVertical}`,
    marginRight && `Margin-right--${marginRight}`,
    marginLeft && `Margin-left--${marginLeft}`,
    marginTop && `Margin-top--${marginTop}`,
    marginBottom && `Margin-bottom--${marginBottom}`,
    marginHorizontal && `Margin-horizontal--${marginHorizontal}`,
    marginVertical && `Margin-vertical--${marginVertical}`,
    background && `Box-background--${background}`,
    divider && 'Box-divider',
    dividerColor && `Box-divider-color--${dividerColor}`,
    dividerSide && `Box-divider--${dividerSide}`,
    border && 'Box-border',
    cursor && `Box-cursor--${cursor}`,
    borderRadius && `Box-borderRadius--${borderRadius}`,
    width && `Box-width--${width}`
  );

  return (
    <div
      style={style}
      className={boxClass}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export default Box;